import React, { useEffect, useState } from 'react';
import '../App.css'; // 引入你的樣式
import { useTranslation } from 'react-i18next'; // 引入翻譯功能
import { Link } from 'react-router-dom'; // 引入路由連結
import '../Styles/Home.css'; // 新增Home頁面專用樣式
import { FaArrowRight } from 'react-icons/fa'; // 引入圖標

function Home() {
  const { t } = useTranslation(); // 使用 useTranslation 來加載翻譯內容
  const [showImage, setShowImage] = useState(false); // 控制照片顯示狀態
  const [isLoaded, setIsLoaded] = useState(false); // 控制元素載入狀態
  const [isMobile, setIsMobile] = useState(false); // 檢測是否為手機版

  useEffect(() => {
    // 更新年份
    document.getElementById('currentYear').textContent =
      new Date().getFullYear();

    // 檢測螢幕寬度，判斷是否為手機版
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // 初始檢測
    checkIsMobile();

    // 監聽視窗大小變化
    window.addEventListener('resize', checkIsMobile);

    // 頁面動畫載入效果
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  // 切換照片顯示狀態
  const toggleImageVisibility = () => {
    setShowImage(!showImage);
  };

  // 手機版佈局
  const renderMobileLayout = () => {
    return (
      <div className={`${isLoaded ? 'content-loaded' : 'content-hidden'}`}>
        {/* 個人資料卡片 */}
        <div
          className={`mobile-card mobile-profile-card ${isLoaded ? 'fade-in-element' : ''}`}
        >
          <div className="mobile-avatar-container">
            <img
              src="/images/profile.jpg"
              alt="Hok Keung"
              className="mobile-avatar"
            />
          </div>
          <h1 className="mobile-name">{t('home.name') || '馮學強'}</h1>
          <p className="mobile-title"></p>
          <p className="mobile-location">Toronto, Canada</p>
        </div>

        {/* 關於我卡片 */}
        <div
          className={`mobile-card ${isLoaded ? 'fade-in-element delay-1' : ''}`}
        >
          <h2 className="mobile-section-title">
            {t('home.about.title') || 'About Hok Keung'}
          </h2>
          <p className="mobile-text">
            {t('home.about.paragraph1') ||
              '馮學強目前以多倫多為據點，憑藉在香港與加拿大的生活經驗，培養出高度的跨文化適應能力與靈活的思維方式。他擁有金融服務與客戶服務領域的工作經驗，擅長在複雜系統中提供支援與問題解決，並能以清晰、有結構的方式向使用者傳遞資訊。'}
          </p>
          <p className="mobile-text">
            {t('home.about.paragraph2') ||
              '他精通英語、粵語及普通話，能夠在多元背景的環境中有效溝通。目前正持續學習日語，並提升 React、JavaScript 等現代網頁開發技術能力。累積超過五年的客戶導向經驗，使他具備良好的分析能力與應變能力，並持續結合科技與使用者體驗，創造更具價值的解決方案。'}
          </p>
        </div>

        {/* 查看作品按鈕 */}
        <div
          className={`mobile-card mobile-work-cta ${isLoaded ? 'fade-in-element delay-2' : ''}`}
        >
          <Link to="/my-work" className="work-cta-button">
            <span>{t('home.viewWork') || 'Check out some of my own work'}</span>
            <FaArrowRight size={16} />
          </Link>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`home-content ${isLoaded ? 'content-loaded' : 'content-hidden'}`}
    >
      {/* 根據裝置類型渲染不同的佈局 */}
      {isMobile ? (
        renderMobileLayout()
      ) : (
        <div className="home-content-wrapper">
          <div
            className={`profile-header ${isLoaded ? 'fade-in-element' : ''}`}
          >
            <div
              className={`profile-name-container ${isLoaded ? 'fade-in-element delay-1' : ''}`}
            >
              <div
                className={`image-wrapper ${showImage ? 'show-image' : 'blur-image'}`}
              >
                <img
                  alt="Hok Keung"
                  className="profile-image"
                  src="/images/profile.jpg"
                />
                {!showImage && (
                  <button
                    className="show-image-btn"
                    onClick={toggleImageVisibility}
                  >
                    {t('home.showImage') || '點擊顯示'}
                  </button>
                )}
              </div>
            </div>
            <div
              className={`profile-story ${isLoaded ? 'fade-in-element delay-2' : ''}`}
            >
              <h1 className="profile-name gradient-text">
                {t('home.name') || '馮學強'}
              </h1>

              <div className="story-section">
                <h2 className="section-title gradient-text">
                  {t('home.about.title') || 'About Hok Keung'}
                </h2>
                <p className="story-paragraph">
                  {t('home.about.paragraph1') ||
                    '馮學強目前以多倫多為據點，憑藉在香港與加拿大的生活經驗，培養出高度的跨文化適應能力與靈活的思維方式。他擁有金融服務與客戶服務領域的工作經驗，擅長在複雜系統中提供支援與問題解決，並能以清晰、有結構的方式向使用者傳遞資訊。'}
                </p>
                <p className="story-paragraph">
                  {t('home.about.paragraph2') ||
                    '他精通英語、粵語及普通話，能夠在多元背景的環境中有效溝通。目前正持續學習日語，並提升 React、JavaScript 等現代網頁開發技術能力。累積超過五年的客戶導向經驗，使他具備良好的分析能力與應變能力，並持續結合科技與使用者體驗，創造更具價值的解決方案。'}
                </p>
              </div>
            </div>
          </div>

          <div
            className={`work-cta-container ${isLoaded ? 'fade-in-element delay-3' : ''}`}
          >
            <Link to="/my-work" className="work-cta-button">
              <span>
                {t('home.viewWork') || 'Check out some of my own work'}
              </span>
              <FaArrowRight size={18} />
            </Link>
          </div>

          <footer
            className={`home-footer ${isLoaded ? 'fade-in-element delay-5' : ''}`}
          >
            <p className="copyright">
              &copy; <span id="currentYear"></span> 馮學強.{' '}
              {t('home.connect.rights') || '版權所有。'}
            </p>
          </footer>
        </div>
      )}
    </div>
  );
}

export default Home;
